import { Controller } from "@hotwired/stimulus"
import { debounce } from "underscore"

export default class extends Controller {
  static targets = ["input", "indicator", "hints"]
  static values = {
    url: String
  }
  static options = null

  async connect() {
    this.element.addEventListener(`input`, debounce(this.changeEventHandler.bind(this), 200))
  }

  async changeEventHandler(event) {
    if(this.inputTarget.value.length <= 0) {
      this.indicatorTarget.value = -1
      this.hintsTarget.replaceChildren([])
      return
    }

    const body = new FormData(this.formElement)
    body.delete(`_method`)

    const request = await fetch(this.urlValue, {
      method: `POST`,
      body: body
    })

    let response

    try {
      response = await request.json()

      // Throw away older requests if we got a newer one
      if(this._updateFloor && this._updateFloor > response.update_floor) {
        return
      } else {
        this._updateFloor = response.update_floor
      }

      this.indicatorTarget.value = response.score

      this.hintsTarget.replaceChildren([])

      response.suggestions.forEach(suggestion => {
        const listItemElement = document.createElement(`LI`)
        listItemElement.textContent = suggestion
        this.hintsTarget.append(listItemElement)
      })

      if(response.warning) {
        const listItemElement = document.createElement(`LI`)
        listItemElement.textContent = response.warning
        this.hintsTarget.append(listItemElement)
      }
    } catch {
      this.indicatorTarget.value = -1
      this.hintsTarget.replaceChildren([])
    }
  }

  get formElement() {
    return this.inputTarget.form
  }
 }
